import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=4e64f832&scoped=true"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"
import style0 from "./MediaList.vue?vue&type=style&index=0&id=4e64f832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64f832",
  null
  
)

export default component.exports